import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 运营部分
 *
 */


// 调剂状态查询 
export const getAdjustUserLog = (query) => {
  return request({
    url: `${prefix}/college/adjustSVip/adjustUserLog`,
    method: 'get',
    params: query
  })
}

// 修改调剂状态 
export const adjustUserLog = (query) => {
  return request({
    url: `${prefix}/college/adjustSVip/adjustUserLog`,
    method: 'put',
    data: query
  })
}


/**
 * VIP产品查询：列表
 * @param {*} query
 */
export const vipProductList = (query) => {
  return request({
    url: `${prefix}/vipProduct/list`,
    method: 'get',
    params: query
  })
}

/**
 * VIP产品查询
 * @param {*} query
 */
export const vipProductOne = (query) => {
  return request({
    url: `${prefix}/vipProduct`,
    method: 'get',
    params: query
  })
}

/**
 * VIP产品创建
 * @param {*} query
 */
export const vipProductCreate = (query) => {
  return request({
    url: `${prefix}/vipProduct`,
    method: 'post',
    data: query
  })
}

/**
 * VIP产品修改
 * @param {*} query
 */
export const vipProductUpdate = (query) => {
  return request({
    url: `${prefix}/vipProduct`,
    method: 'put',
    data: query
  })
}

/**
 * VIP产品删除
 * @param {*} query
 */
export const vipProductDestroy = (query) => {
  return request({
    url: `${prefix}/vipProduct`,
    method: 'delete',
    data: query
  })
}


/**
 * 平台学长服务费用查询：列表
 * @param {*} query
 */
export const serviceChargeList = (query) => {
  return request({
    url: `${prefix}/serviceCharge/list`,
    method: 'get',
    params: query
  })
}

/**
 * 平台学长服务费用查询
 * @param {*} query
 */
export const serviceChargeOne = (query) => {
  return request({
    url: `${prefix}/serviceCharge`,
    method: 'get',
    params: query
  })
}

/**
 * 平台学长服务费用创建
 * @param {*} query
 */
export const serviceChargeCreate = (query) => {
  return request({
    url: `${prefix}/serviceCharge`,
    method: 'post',
    data: query
  })
}

/**
 * 平台学长服务费用修改
 * @param {*} query
 */
export const serviceChargeUpdate = (query) => {
  return request({
    url: `${prefix}/serviceCharge`,
    method: 'put',
    data: query
  })
}

/**
 * 平台学长服务费用删除
 * @param {*} query
 */
export const serviceChargeDestroy = (query) => {
  return request({
    url: `${prefix}/serviceCharge`,
    method: 'delete',
    data: query
  })
}


/**
 * 平台推荐返佣费用查询：列表
 * @param {*} query
 */
export const marketingChargeList = (query) => {
  return request({
    url: `${prefix}/marketingCharge/list`,
    method: 'get',
    params: query
  })
}

/**
 * 平台推荐返佣费用查询
 * @param {*} query
 */
export const marketingChargeOne = (query) => {
  return request({
    url: `${prefix}/marketingCharge`,
    method: 'get',
    params: query
  })
}

/**
 * 平台推荐返佣费用创建
 * @param {*} query
 */
export const marketingChargeCreate = (query) => {
  return request({
    url: `${prefix}/marketingCharge`,
    method: 'post',
    data: query
  })
}

/**
 * 平台推荐返佣费用修改
 * @param {*} query
 */
export const marketingChargeUpdate = (query) => {
  return request({
    url: `${prefix}/marketingCharge`,
    method: 'put',
    data: query
  })
}

/**
 * 平台推荐返佣费用删除
 * @param {*} query
 */
export const marketingChargeDestroy = (query) => {
  return request({
    url: `${prefix}/marketingCharge`,
    method: 'delete',
    data: query
  })
}



/**
 * 广告查询：列表
 * @param {*} query
 */
export const adList = (query) => {
  return request({
    url: `${prefix}/poster/list`,
    method: 'get',
    params: query
  })
}

/**
 * 广告查询
 * @param {*} query
 */
export const adOne = (query) => {
  return request({
    url: `${prefix}/poster`,
    method: 'get',
    params: query
  })
}

/**
 * 广告创建
 * @param {*} query
 */
export const adCreate = (query) => {
  return request({
    url: `${prefix}/poster`,
    method: 'post',
    data: query
  })
}

/**
 * 广告修改
 * @param {*} query
 */
export const adUpdate = (query) => {
  return request({
    url: `${prefix}/poster`,
    method: 'put',
    data: query
  })
}

/**
 * 广告删除
 * @param {*} query
 */
export const adDestroy = (query) => {
  return request({
    url: `${prefix}/poster`,
    method: 'delete',
    data: query
  })
}


/**
 * 广告位置查询：列表
 * @param {*} query
 */
export const adPositionList = (query) => {
  return request({
    url: `${prefix}/adPosition/list`,
    method: 'get',
    params: query
  })
}

/**
 * 广告位置查询
 * @param {*} query
 */
export const adPositionOne = (query) => {
  return request({
    url: `${prefix}/adPosition`,
    method: 'get',
    params: query
  })
}

/**
 * 广告位置创建
 * @param {*} query
 */
export const adPositionCreate = (query) => {
  return request({
    url: `${prefix}/adPosition`,
    method: 'post',
    data: query
  })
}

/**
 * 广告位置修改
 * @param {*} query
 */
export const adPositionUpdate = (query) => {
  return request({
    url: `${prefix}/adPosition`,
    method: 'put',
    data: query
  })
}

/**
 * 广告位置删除
 * @param {*} query
 */
export const adPositionDestroy = (query) => {
  return request({
    url: `${prefix}/adPosition`,
    method: 'delete',
    data: query
  })
}


/**
 * 客户端查询：列表
 * @param {*} query
 */
export const clientList = (query) => {
  return request({
    url: `${prefix}/client/list`,
    method: 'get',
    params: query
  })
}

/**
 * 客户端查询
 * @param {*} query
 */
export const clientOne = (query) => {
  return request({
    url: `${prefix}/client`,
    method: 'get',
    params: query
  })
}

/**
 * 客户端创建
 * @param {*} query
 */
export const clientCreate = (query) => {
  return request({
    url: `${prefix}/client`,
    method: 'post',
    data: query
  })
}

/**
 * 客户端修改
 * @param {*} query
 */
export const clientUpdate = (query) => {
  return request({
    url: `${prefix}/client`,
    method: 'put',
    data: query
  })
}

/**
 * 客户端删除
 * @param {*} query
 */
export const clientDestroy = (query) => {
  return request({
    url: `${prefix}/client`,
    method: 'delete',
    data: query
  })
}


/**
 * 系统配置查询：列表
 * @param {*} query
 */
export const configureList = (query) => {
  return request({
    url: `${prefix}/configure/list`,
    method: 'get',
    params: query
  })
}

/**
 * 系统配置查询
 * @param {*} query
 */
export const configureOne = (query) => {
  return request({
    url: `${prefix}/configure`,
    method: 'get',
    params: query
  })
}

/**
 * 系统配置创建
 * @param {*} query
 */
export const configureCreate = (query) => {
  return request({
    url: `${prefix}/configure`,
    method: 'post',
    data: query
  })
}

/**
 * 系统配置修改
 * @param {*} query
 */
export const configureUpdate = (query) => {
  return request({
    url: `${prefix}/configure`,
    method: 'put',
    data: query
  })
}

/**
 * 系统配置删除
 * @param {*} query
 */
export const configureDestroy = (query) => {
  return request({
    url: `${prefix}/configure`,
    method: 'delete',
    data: query
  })
}




/**
 * 消息分类查询：列表
 * @param {*} query
 */
export const noticeCategoryList = (query) => {
  return request({
    url: `${prefix}/notice/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 消息分类查询
 * @param {*} query
 */
export const noticeCategoryOne = (query) => {
  return request({
    url: `${prefix}/notice/category`,
    method: 'get',
    params: query
  })
}

/**
 * 消息分类创建
 * @param {*} query
 */
export const noticeCategoryCreate = (query) => {
  return request({
    url: `${prefix}/notice/category`,
    method: 'post',
    data: query
  })
}

/**
 * 消息分类修改
 * @param {*} query
 */
export const noticeCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/notice/category`,
    method: 'put',
    data: query
  })
}

/**
 * 消息分类删除
 * @param {*} query
 */
export const noticeCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/notice/category`,
    method: 'delete',
    data: query
  })
}


/**
 * 系统消息查询：列表
 * @param {*} query
 */
export const noticeList = (query) => {
  return request({
    url: `${prefix}/notice/list`,
    method: 'get',
    params: query
  })
}

/**
 * 系统消息查询
 * @param {*} query
 */
export const noticeOne = (query) => {
  return request({
    url: `${prefix}/notice`,
    method: 'get',
    params: query
  })
}

/**
 * 系统消息创建
 * @param {*} query
 */
export const noticeCreate = (query) => {
  return request({
    url: `${prefix}/notice`,
    method: 'post',
    data: query
  })
}

/**
 * 系统消息修改
 * @param {*} query
 */
export const noticeUpdate = (query) => {
  return request({
    url: `${prefix}/notice`,
    method: 'put',
    data: query
  })
}

/**
 * 系统消息推送
 * @param {*} query
 */
export const noticePush = (query) => {
  return request({
    url: `${prefix}/notice/push`,
    method: 'post',
    data: query
  })
}

/**
 * 系统消息删除
 * @param {*} query
 */
export const noticeDestroy = (query) => {
  return request({
    url: `${prefix}/notice`,
    method: 'delete',
    data: query
  })
}


/**
 * 菜单查询：列表
 * @param {*} query
 */
export const menuList = (query) => {
  return request({
    url: `${prefix}/menu/list`,
    method: 'get',
    params: query
  })
}

/**
 * 菜单查询
 * @param {*} query
 */
export const menuOne = (query) => {
  return request({
    url: `${prefix}/menu`,
    method: 'get',
    params: query
  })
}

/**
 * 菜单创建
 * @param {*} query
 */
export const menuCreate = (query) => {
  return request({
    url: `${prefix}/menu`,
    method: 'post',
    data: query
  })
}

/**
 * 菜单修改
 * @param {*} query
 */
export const menuUpdate = (query) => {
  return request({
    url: `${prefix}/menu`,
    method: 'put',
    data: query
  })
}

/**
 * 菜单删除
 * @param {*} query
 */
export const menuDestroy = (query) => {
  return request({
    url: `${prefix}/menu`,
    method: 'delete',
    data: query
  })
}


/**
 * 菜单位置查询：列表
 * @param {*} query
 */
export const menuPositionList = (query) => {
  return request({
    url: `${prefix}/menu/position/list`,
    method: 'get',
    params: query
  })
}

/**
 * 菜单位置查询
 * @param {*} query
 */
export const menuPositionOne = (query) => {
  return request({
    url: `${prefix}/menu/position`,
    method: 'get',
    params: query
  })
}

/**
 * 菜单位置创建
 * @param {*} query
 */
export const menuPositionCreate = (query) => {
  return request({
    url: `${prefix}/menu/position`,
    method: 'post',
    data: query
  })
}

/**
 * 菜单位置修改
 * @param {*} query
 */
export const menuPositionUpdate = (query) => {
  return request({
    url: `${prefix}/menu/position`,
    method: 'put',
    data: query
  })
}

/**
 * 菜单位置删除
 * @param {*} query
 */
export const menuPositionDestroy = (query) => {
  return request({
    url: `${prefix}/menu/position`,
    method: 'delete',
    data: query
  })
}


/**
 * 优惠券查询：列表
 * @param {*} query
 */
export const couponList = (query) => {
  return request({
    url: `${prefix}/coupon/list`,
    method: 'get',
    params: query
  })
}

/**
 * 优惠券查询
 * @param {*} query
 */
export const couponOne = (query) => {
  return request({
    url: `${prefix}/coupon`,
    method: 'get',
    params: query
  })
}

/**
 * 优惠券创建
 * @param {*} query
 */
export const couponCreate = (query) => {
  return request({
    url: `${prefix}/coupon`,
    method: 'post',
    data: query
  })
}

/**
 * 优惠券修改
 * @param {*} query
 */
export const couponUpdate = (query) => {
  return request({
    url: `${prefix}/coupon`,
    method: 'put',
    data: query
  })
}

/**
 * 优惠券删除
 * @param {*} query
 */
export const couponDestroy = (query) => {
  return request({
    url: `${prefix}/coupon`,
    method: 'delete',
    data: query
  })
}


/**
 * QQ群查询：列表
 * @param {*} query
 */
export const qqGroupList = (query) => {
  return request({
    url: `${prefix}/qq/group/list`,
    method: 'get',
    params: query
  })
}

/**
 * QQ群查询
 * @param {*} query
 */
export const qqGroupOne = (query) => {
  return request({
    url: `${prefix}/qq/group`,
    method: 'get',
    params: query
  })
}

/**
 * QQ群创建
 * @param {*} query
 */
export const qqGroupCreate = (query) => {
  return request({
    url: `${prefix}/qq/group`,
    method: 'post',
    data: query
  })
}

/**
 * QQ群修改
 * @param {*} query
 */
export const qqGroupUpdate = (query) => {
  return request({
    url: `${prefix}/qq/group`,
    method: 'put',
    data: query
  })
}

/**
 * QQ群删除
 * @param {*} query
 */
export const qqGroupDestroy = (query) => {
  return request({
    url: `${prefix}/qq/group`,
    method: 'delete',
    data: query
  })
}


/**
 * 活动查询：列表
 * @param {*} query
 */
export const activityList = (query) => {
  return request({
    url: `${prefix}/activity/list`,
    method: 'get',
    params: query
  })
}

/**
 * 活动查询
 * @param {*} query
 */
export const activityOne = (query) => {
  return request({
    url: `${prefix}/activity`,
    method: 'get',
    params: query
  })
}

/**
 * 活动创建
 * @param {*} query
 */
export const activityCreate = (query) => {
  return request({
    url: `${prefix}/activity`,
    method: 'post',
    data: query
  })
}

/**
 * 活动修改
 * @param {*} query
 */
export const activityUpdate = (query) => {
  return request({
    url: `${prefix}/activity`,
    method: 'put',
    data: query
  })
}

/**
 * 活动下线
 * @param {*} query
 */
export const activityOffline = (query) => {
  return request({
    url: `${prefix}/activity/offline`,
    method: 'post',
    data: query
  })
}

/**
 * 活动删除
 * @param {*} query
 */
export const activityDestroy = (query) => {
  return request({
    url: `${prefix}/activity`,
    method: 'delete',
    data: query
  })
}


/**
 * 积分任务查询：列表
 * @param {*} query
 */
export const pointsTaskList = (query) => {
  return request({
    url: `${prefix}/member/points/task/list`,
    method: 'get',
    params: query
  })
}

/**
 * 积分任务查询
 * @param {*} query
 */
export const pointsTaskOne = (query) => {
  return request({
    url: `${prefix}/member/points/task`,
    method: 'get',
    params: query
  })
}

/**
 * 积分任务创建
 * @param {*} query
 */
export const pointsTaskCreate = (query) => {
  return request({
    url: `${prefix}/member/points/task`,
    method: 'post',
    data: query
  })
}

/**
 * 积分任务修改
 * @param {*} query
 */
export const pointsTaskUpdate = (query) => {
  return request({
    url: `${prefix}/member/points/task`,
    method: 'put',
    data: query
  })
}

/**
 * 积分任务删除
 * @param {*} query
 */
export const pointsTaskDestroy = (query) => {
  return request({
    url: `${prefix}/member/points/task`,
    method: 'delete',
    data: query
  })
}


/**
 * 协议查询：列表
 * @param {*} query
 */
export const agreementList = (query) => {
  return request({
    url: `${prefix}/agreement/list`,
    method: 'get',
    params: query
  })
}

/**
 * 协议查询
 * @param {*} query
 */
export const agreementOne = (query) => {
  return request({
    url: `${prefix}/agreement`,
    method: 'get',
    params: query
  })
}

/**
 * 协议创建
 * @param {*} query
 */
export const agreementCreate = (query) => {
  return request({
    url: `${prefix}/agreement`,
    method: 'post',
    data: query
  })
}

/**
 * 协议修改
 * @param {*} query
 */
export const agreementUpdate = (query) => {
  return request({
    url: `${prefix}/agreement`,
    method: 'put',
    data: query
  })
}

/**
 * 协议删除
 * @param {*} query
 */
export const agreementDestroy = (query) => {
  return request({
    url: `${prefix}/agreement`,
    method: 'delete',
    data: query
  })
}


/**
 * 联报（查询列表）
 * @param {*} query
 */
export const joinlist = (query) => {
  return request({
    url: `${prefix}/joint/list`,
    method: 'get',
    params: query
  })
}


/**
 * 联报（创建）
 * @param {*} query
 */
export const createJoint = (query) => {
  return request({
    url: `${prefix}/joint`,
    method: 'post',
    data: query
  })
}

/**
 * 联报（删除）
 * @param {*} query
 */
export const jointDestory = (query) => {
  return request({
    url: `${prefix}/joint`,
    method: 'delete',
    data: query
  })
}

/**
 * 联报（查询详情）
 * @param {*} query
 */
export const jointOne = (query) => {
  return request({
    url: `${prefix}/joint`,
    method: 'get',
    params: query
  })
}


/**
 * 联报（修改） 
 * @param {*} query
 */
export const editjoint = (query) => {
  return request({
    url: `${prefix}/joint`,
    method: 'put',
    data: query
  })
}


/**
 * 拼团（根据订单查询详情）
 * @param {*} query
 */
export const memberActivityOrderOne = (query) => {
  return request({
    url: `${prefix}/member/activity/order`,
    method: 'get',
    params: query
  })
}



/**
 * 小程序（查询列表）
 * @param {*} query
 */
export const miniProgramlist = (query) => {
  return request({
    url: `${prefix}/miniProgram/list`,
    method: 'get',
    params: query
  })
}


/**
 * 小程序（创建）
 * @param {*} query
 */
export const createMiniProgram = (query) => {
  return request({
    url: `${prefix}/miniProgram`,
    method: 'post',
    data: query
  })
}


/**
 * 小程序（修改） 
 * @param {*} query
 */
export const editMiniProgram = (query) => {
  return request({
    url: `${prefix}/miniProgram`,
    method: 'put',
    data: query
  })
}


/**
 * 联小程序（删除）
 * @param {*} query
 */
export const miniProgramDestory = (query) => {
  return request({
    url: `${prefix}/miniProgram`,
    method: 'delete',
    data: query
  })
}

/**
 * 短信模板（查询列表）
 * @param {*} query
 */
export const smsTemplatelist = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsTemplate/list`,
    method: 'get',
    params: query
  })
}


/**
 * 短信模板（删除）
 * @param {*} query
 */
export const smsTemplateDelete = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsTemplate`,
    method: 'delete',
    data: query
  })
}


/**
 * 短信签名（查询列表）
 * @param {*} query
 */
export const smsSignlist = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsSign/list`,
    method: 'get',
    params: query
  })
}



/**
 * 短信模板（查询变量列表）
 * @param {*} query
 */
export const smsTemplatevariablelist = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsTemplate/variable/list`,
    method: 'get',
    params: query
  })
}



/**
 * 短信模板（创建）
 * @param {*} query
 */
export const smsTemplateCreate = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsTemplate`,
    method: 'post',
    data: query
  })
}

/**
 * 短信模板（修改）
 * @param {*} query
 */
export const editSmsTemplate = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsTemplate`,
    method: 'put',
    data: query
  })
}

/**
 * 短信发送任务（查询列表）
 * @param {*} query
 */
export const smsSendTasklist = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsSendTask/list`,
    method: 'get',
    params: query
  })
}

/**
 * 短信发送任务单个消息（查询列表）
 * @param {*} query
 */
export const smsSendTasksinglelist = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsSendTask/single/list`,
    method: 'get',
    params: query
  })
}


/**
 * 短信发送任务（创建）
 * @param {*} query
 */
export const smsSendTaskCreate = (query) => {
  return request({
    url: `${prefix}/smsAdmin/smsSendTask`,
    method: 'post',
    data: query
  })
}


/**
 * 组合课（创建）
 * @param {*} query
 */
export const bucketCourseCreate = (query) => {
  return request({
    url: `${prefix}/bucketCourse`,
    method: 'post',
    data: query
  })
}

/**
 * 组合课（查询列表）
 * @param {*} query
 */
export const bucketCourselist = (query) => {
  return request({
    url: `${prefix}/bucketCourse/list`,
    method: 'get',
    params: query
  })
}

/**
 * 组合课（删除）
 * @param {*} query
 */
export const bucketCourseDelete = (query) => {
  return request({
    url: `${prefix}/bucketCourse`,
    method: 'delete',
    data: query
  })
}

/**
 * 组合课（查询详情）
 * @param {*} query
 */
export const bucketCourseOne = (query) => {
  return request({
    url: `${prefix}/bucketCourse`,
    method: 'get',
    params: query
  })
}

/**
 * 组合课（修改）
 * @param {*} query
 */
export const editBucketCourse = (query) => {
  return request({
    url: `${prefix}/bucketCourse`,
    method: 'put',
    data: query
  })
}